module.exports = __webpack_public_path__ + "static/media/front.cc58df77.jpg";